import React, { useEffect, useState } from "react";

import { Box, Button, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import Swal from "sweetalert2";
import ActiveSwitchFile from "../../../components/SwitchFile";
import DeletePop from "../../../constants/ErrorPermissionModal";
import { constants } from "../../../constants/constants";

import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import YouTubeEmbed from "../../../components/Banner/YouTubeEmbed";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import { addlog } from "../../../utils/ApiCalls/Logs";
import {
  deleteActivityCategory,
  getActivityCategory,
  updateActivitySingleCategory,
  updatePosition,
} from "../../../utils/ApiCalls/Mobile/ActivityMasters";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import CloseIcon from '@mui/icons-material/Close';
import { LOG_ACTIONS ,LOG_TYPES} from "../../../utils/Constant/LogConstant";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  maxHeight: "90%",
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  overflow: "scroll",
  p: 4,
};

const SubActivityCategory = ({ record, activeCat, setActiveCat,vesselId,refreshParentCategories }) => {
  const navigate = useNavigate();
  const [vesselOptions, setVesselOptions] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [rows, setRows] = useState([]);
  const [active, setActive] = useState("listing");
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const [columns, setColumns] = useState([]);
  const [sort, setSort] = useState();
  const [order, setOrder] = useState();
  const handleOpen = () => {
    getData(1);
    setPage(1);
    setActiveCat(record.id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    refreshParentCategories();
  };

  const sortHandler = async (options) => {
    if (Object.keys(options).length > 0) {
      let sort, order;
      sort = options.columnKey;
      order =
        options.order === "ascend"
          ? "asc"
          : options.order === "descend"
          ? "desc"
          : undefined;
      setSort(sort);
      setOrder(order);
      await getData(1, sort, order);
    }
  };
  const setPositionalValue = (data) => {};

  const updateBannerPosition = async (banners) => {
    if (checkPermission(permission, "update_per", "Categories",window?.location?.pathname)) {
      try {
        let args = { search: search, page: page, limit: pageSize, vesselId };

        const data = await updatePosition(banners, args);
        addlog("Categories Position Updated", "Categories", {}, userDetails.id);
        if (data.error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.error,
          });
        } else if (data.data) {
          setRows(data.data);
          setCount(data.count);
          setPositionalValue(data.data);
        }
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
      } catch (error) {
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message || "Unknown error occurred",
        });
      }
    } else {
      message.error("Update permission missing");
    }
  };
  useEffect(() => {
    setColumns([
      {
        title: "Sl",
        width: 10,
        dataIndex: "id",
        key: "id",
        fixed: "left",
        render: (position, record, index) => (page - 1) * pageSize + index + 1,
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: 100,
        render: (item) => <div dangerouslySetInnerHTML={{ __html: item }} />,
      },
      {
        title: "Status",
        dataIndex: "is_active",
        key: "is_active",
        width: 30,
        sorter: (a, b) => "",
        render: (item, record, index) => (
          <ActiveSwitchFile
            item={item}
            record={record}
            index={index}
            handleUpdate={handleUpdate}
          />
        ),
      },
      {
        title: "Action",
        key: "operation",
        width: 100,
        render: (text, record) => (
          <div className="table_action_btn">
            <button className="btn" onClick={() => handleEdit(record.id)}>
              <i
                className="ri-edit-2-line"
                data-toggle="tooltip"
                title="Edit"
              ></i>
            </button>
         
              <DeletePop onConfirm={()=>handleDelete(record.id)} title={`Delete ${record.name ?? "this"} Sub Category`}>
                {" "}
                <button className="btn delete_btn">
                  <i
                    className="ri-delete-bin-line"
                    data-toggle="tooltip"
                    title="Delete"
                  ></i>
                </button>
              </DeletePop>
 
          </div>
        ),
      },
    ]);
  }, [vesselOptions, vesselId, page]);
  useEffect(() => {
    if (activeCat) {
      getData(page, sort, order);
    }
  }, [page, pageSize, search, vesselId, sort, order]);
  const handleUpdate = async (id, values, title, location_id) => {
    if (checkPermission(permission, "update_per", "Categories",window?.location?.pathname)) {
      let data = await updateActivitySingleCategory(id, values);
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
          addlog(
          `Sub Categories of ${record?.name} ` +
            (!values.valid_from
              ? values.is_active === 1
                ? LOG_ACTIONS.ACTIVATED
                : LOG_ACTIONS.DEACTIVATED
              : LOG_ACTIONS.UPDATED),
          "Categories",
          { ...values, id, title },
          userDetails.id
        );
      }
      getData(page, sort, order);
    } else {
      message.error("Update permission missing");
    }
  };

  const getData = async (value, sortParam, orderParam) => {
    let data = await getActivityCategory({
      page: value,
      limit: pageSize,
      vessel_id: vesselId,
      search,
      parent_category: record?.id,
      sort: sortParam !== undefined ? sortParam : sort,
      order: orderParam !== undefined ? orderParam : order,
    });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
  };
  const handleEdit = async (id) => {
    if (checkPermission(permission, "update_per", "Categories",window?.location?.pathname)) {
      navigate("/shore/mobile-masters/activity-categories/edit/" + id);
    } else {
      message.error("Update permission missing");
    }
  };
  const handleDelete = async (id) => {
    if (checkPermission(permission, "delete_per", "Categories",window?.location?.pathname)) {
      let val = await deleteActivityCategory(id);
      addlog(LOG_ACTIONS.REMOVED, LOG_TYPES.CATEGORIES, { id ,title: record?.name,location_id: record?.location_id}, userDetails.id);
    
      if (val.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: val.error,
        });
      } else {
        await getData(page, sort, order);
      }
    } else {
      message.error("Missing Permission for delete");
    }
  };

  return (
    <div>
      <Button variant="contained" onClick={handleOpen}>
        {record?.pageCount} Sub Categories
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <h4>({record?.name}) Sub Categories</h4>
              <IconButton onClick={handleClose} sx={{ ml: 2 }}>
                <CloseIcon />
              </IconButton>
            </Box>
          {rows && columns && (
            <CustomizedTable
              setRows={setRows}
              setPageSize={setPageSize}
              setPage={setPage}
              pageSize={pageSize}
              page={page}
              count={count}
              columns={columns}
              rows={rows}
              title={"Crisis Page"}
              sortHandler={sortHandler}
              updatePosition={updateBannerPosition}
            />
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default SubActivityCategory;
